import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
import useViewport from "../../hooks/useViewport";

import Textarea from "../../components/Textarea";
import Slider from '../../components/Slider';
import Gallery from '../../components/Gallery';

import "./style.css"

function Planning() {
    const { isDesktop } = useViewport();
    const [dataPage, setDataPage] = useState(null);
    const { language } = useContext(LangContext);

    useEffect(() => {
        const fetchDataPage = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/planning/get`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);

            setDataPage({
                descrip_fr: res.descrip_fr || '',
                descrip_en: res.descrip_en || '',
                images: res.images || [],
                gallery: res.gallery || [],
                video: res.video || [],
            });
        }
        fetchDataPage();
    }, []);

    return dataPage && (
        <div className='page page_planning'>
            <section className="sect_presentation">
                <div className="planning_descrip">
                    <h2 className={`${isDesktop ? 'sub' : ''}title_page`}>-<span>Planning</span>-</h2>
                    <Textarea text={dataPage[`descrip_${language}`]} />
                </div>

                <Slider images={dataPage.images} />
            </section>

            {dataPage.video.length !== 0 &&
                <section className="sect_videos">
                    <ul>
                        {dataPage.video.map((url, idx) =>
                            <li key={idx} className="video">
                                <iframe
                                    title="video"
                                    src={url.replace("youtube.com", "youtube-nocookie.com")}

                                    width="100%"
                                    height="100%"

                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </li>
                        )}
                    </ul>
                </section>
            }

            {dataPage.gallery.length !== 0 &&
                <section className="sect_gallery">
                    <Gallery images={dataPage.gallery} />
                </section>
            }
        </div>
    )
}

export default Planning;